import React from "react";

export interface RefEntry {
  id?: string;
  code?: string;
  libelle: string;
  groupe?: string | null;
  couleur?: string | null;
  actif?: boolean;
}

export function RefSelect({
  entries,
  value,
  onChange,
  testId,
  groupes,
  placeholder = "—",
  disabled,
  required,
  className,
}: {
  entries: RefEntry[];
  value: string | null | undefined;
  onChange: (v: string | null) => void;
  testId?: string;
  groupes?: string[];
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}) {
  const actifs = (entries || []).filter((e) => e.actif !== false);
  const connue = !!value && (entries || []).some((e) => e.libelle === value);
  const horsListe = !!value && !actifs.some((e) => e.libelle === value);
  const option = (e: RefEntry) => <option key={e.id || e.libelle} value={e.libelle}>{e.libelle}</option>;
  return (
    <select data-testid={testId} className={`nx-input ${className || ""}`} value={value || ""} disabled={disabled} required={required} onChange={(e) => onChange(e.target.value || null)}>
      <option value="">{placeholder}</option>
      {horsListe && <option value={value as string}>{value} {connue ? "(désactivée)" : "(valeur non conforme)"}</option>}
      {groupes
        ? groupes.map((g) => (
            <optgroup key={g} label={g}>
              {actifs.filter((e) => e.groupe === g).map(option)}
            </optgroup>
          ))
        : actifs.map(option)}
    </select>
  );
}

export const GROUPES_PAYS = ["Afrique francophone", "Reste du monde"];

export const COULEUR_BADGE: Record<string, string> = {
  info: "bg-blue-50 text-info",
  neutre: "bg-gray-100 text-gray-700",
  alerte: "bg-amber-50 text-amber",
  lime: "bg-lime-soft text-green",
  succes: "bg-green text-white",
};

export function badgeDe(entries: RefEntry[] | undefined, libelle: string | null | undefined): string {
  const e = (entries || []).find((x) => x.libelle === libelle);
  return COULEUR_BADGE[e?.couleur || "neutre"] || COULEUR_BADGE.neutre;
}

export function codeDe(entries: RefEntry[] | undefined, libelle: string | null | undefined): string | undefined {
  return (entries || []).find((x) => x.libelle === libelle)?.code;
}
